import { render, staticRenderFns } from "./StudentData.vue?vue&type=template&id=1bfe8730&scoped=true&"
import script from "./StudentData.vue?vue&type=script&lang=js&"
export * from "./StudentData.vue?vue&type=script&lang=js&"
import style0 from "./StudentData.vue?vue&type=style&index=0&id=1bfe8730&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfe8730",
  null
  
)

export default component.exports